export default {
  dense: true,
  color: "holder", // "grey lighten-3",
  class: "mb-3 rounded",
  flat: true,
};
